(() => {
  if (customElements.get('cart-drawer-upsell')) {
    return;
  }

  class CartDrawerUpsell extends HTMLElement {
    connectedCallback() {
      this.cartDrawer = this.closest('cart-drawer');
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.submitButton = this.form.querySelector('[name="add"]');
      this.buttonText = this.querySelector('[data-button-text]');
      this.idInput = this.form.querySelector('[name="id"]');
      this.error = this.querySelector('[data-upsell-error]');
      this.selects = Array.from(this.querySelectorAll('[data-select]'));
      this.image = this.querySelector('.cart-upsell__media img');

      try {
        this.variants = JSON.parse(
          this.querySelector('[data-variants]').textContent
        );
      } catch (error) {
        this.variants = [];
      }

      this.onChange = this.onVariantChange.bind(this);
      this.onSubmit = this.onFormSubmit.bind(this);
      this.selects.forEach(select =>
        select.addEventListener('change', this.onChange)
      );
      this.form.addEventListener('submit', this.onSubmit);

      // Options with a single value come preselected; if that already
      // resolves the variant, sync the id and price.
      if (this.selects.length && this.missingSelects().length === 0) {
        this.onVariantChange();
      }
    }

    disconnectedCallback() {
      this.selects?.forEach(select =>
        select.removeEventListener('change', this.onChange)
      );
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    missingSelects() {
      return this.selects.filter(select => !select.value);
    }

    findVariant() {
      const values = this.selects.map(select => select.value);
      return this.variants.find(variant =>
        variant.options.every((option, index) => option === values[index])
      );
    }

    setButton(text, disabled) {
      this.buttonText.textContent = text;
      this.submitButton.disabled = disabled;
    }

    setError(message) {
      if (!this.error) return;
      this.error.textContent = message || '';
      this.error.hidden = !message;
    }

    onVariantChange(event) {
      if (event) {
        event.target
          .closest('.cart-upsell__select')
          ?.classList.remove('is-invalid');
        event.target.removeAttribute('aria-invalid');
      }
      this.setError('');

      // Wait for every option before resolving a variant.
      if (this.missingSelects().length) return;

      this.currentVariant = this.findVariant();

      if (!this.currentVariant) {
        this.setButton(this.dataset.unavailableLabel, true);
        return;
      }

      this.idInput.value = this.currentVariant.id;

      if (this.currentVariant.available) {
        this.setButton(
          // Formatted in Liquid so it matches the customer's currency.
          `${this.dataset.addLabel} - ${this.currentVariant.price_html}`,
          false
        );
      } else {
        this.setButton(this.dataset.soldOutLabel, true);
      }

      if (this.image && this.currentVariant.image) {
        this.image.removeAttribute('srcset');
        this.image.src = this.currentVariant.image;
      }
    }

    onFormSubmit(event) {
      event.preventDefault();

      const missing = this.missingSelects();
      if (missing.length) {
        missing.forEach(select => {
          select.closest('.cart-upsell__select')?.classList.add('is-invalid');
          select.setAttribute('aria-invalid', 'true');
        });
        this.setError(
          `Please select ${missing
            .map(select => select.dataset.name)
            .join(', ')}`
        );
        missing[0].focus();
        return;
      }

      if (!this.cartDrawer || this.submitButton.disabled) return;

      this.submitButton.classList.add('is-loading');
      this.submitButton.setAttribute('aria-busy', 'true');

      addToCart(
        this.form,
        this.cartDrawer.getSectionsToRender().map(section => section.section)
      )
        .then(response => {
          if (response.status) throw new Error(response.description || response.message);
          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          this.setError(error.message || window.cartStrings?.error);
        })
        .finally(() => {
          // The card is usually replaced by the re-render; this covers errors.
          this.submitButton.classList.remove('is-loading');
          this.submitButton.removeAttribute('aria-busy');
        });
    }
  }

  customElements.define('cart-drawer-upsell', CartDrawerUpsell);
})();
